module.exports = __webpack_public_path__ + "static/banner-4-8b249c39045f35700fd898bcdf277212.jpg";